import { FC } from "react";
import styled from "styled-components";
import Box, { BoxProps } from "../elements/Box";

const SelectStyle: FC<{ className?: string } & BoxProps> = styled(Box)<
  BoxProps
>`
  .select__control {
    height: 3rem;
    border-radius: 8px;
    border-color: ${props => props.theme.colors.border};
  }

  .select__single-value {
    color: ${props => props.theme.colors.default};
    font-weight: bold;
  }

  .select__value-container {
    height: 100%;
  }
`;

export const ErrorText = styled.span`
  color: ${props => props.theme.colors.danger};
  margin: 0 1rem;
`;

export default SelectStyle;
